import React from 'react';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { CalendarNavigationProps } from '../types/calendar';

const CalendarNavigation: React.FC<CalendarNavigationProps> = ({
  currentWeek,
  onPreviousWeek,
  onNextWeek,
  onToday,
  workoutsCount,
  isMobile = false
}) => {
  const formatWeekRange = (startDate: Date, endDate: Date): string => {
    if (isMobile) {
      // Для мобильной версии показываем только один день
      const dayFormatted = format(startDate, 'd MMM yyyy', { locale: ru });
      
      // Добавляем количество тренировок в скобках, если оно передано
      if (workoutsCount !== undefined) {
        return `${dayFormatted} (тренировок: ${workoutsCount})`;
      }
      
      return dayFormatted;
    } else {
      // Для десктопа показываем диапазон недели
      const startFormatted = format(startDate, 'd MMM', { locale: ru });
      const endFormatted = format(endDate, 'd MMM yyyy', { locale: ru });
      const range = `${startFormatted} - ${endFormatted}`;
      
      // Добавляем количество тренировок в скобках, если оно передано
      if (workoutsCount !== undefined) {
        return `${range} (тренировок: ${workoutsCount})`;
      }
      
      return range;
    }
  };

  return (
    <div className="flex items-center justify-between bg-white p-3 sm:p-4 border-b border-gray-200">
      {/* Левая часть - навигация */}
      <div className="flex items-center space-x-1 sm:space-x-2">
        <button
          onClick={onPreviousWeek}
          className="p-1.5 sm:p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors"
          aria-label={isMobile ? "Предыдущий день" : "Предыдущая неделя"}
        >
          <ChevronLeft className="h-4 w-4 sm:h-5 sm:w-5" />
        </button>
        
        <button
          onClick={onNextWeek}
          className="p-1.5 sm:p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors"
          aria-label={isMobile ? "Следующий день" : "Следующая неделя"}
        >
          <ChevronRight className="h-4 w-4 sm:h-5 sm:w-5" />
        </button>
      </div>

      {/* Центральная часть - период */}
      <div className="flex items-center space-x-2 sm:space-x-3 flex-1 justify-center">
        <Calendar className="h-4 w-4 sm:h-5 sm:w-5 text-gray-600" />
        <span className="text-sm sm:text-lg font-medium text-gray-900 text-center">
          {formatWeekRange(currentWeek.startDate, currentWeek.endDate)}
        </span>
      </div>

      {/* Правая часть - кнопка "Сегодня" */}
      <div>
        <button
          onClick={onToday}
          className="px-2 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors"
        >
          Сегодня
        </button>
      </div>
    </div>
  );
};

export default CalendarNavigation; 